// ===== Navigator panel: tree of Accounts, Indicators, Expert Advisors, Scripts, Services =====
import { useState } from "react";
import { useStore, setUI, addIndicator, log, setChart, getState, closePosition } from "./store";
import { openMenu } from "./ContextMenu";
import { I } from "./Icons";

const TREE = [
  { id: "acc", label: "Accounts", icon: "folder", children: [{ id: "srv", label: "WebTrade-Demo", icon: "folder", children: [{ id: "a1", label: "51842907: Demo Account", icon: "account" }] }] },
  { id: "ind", label: "Indicators", icon: "folder", children: [
    { id: "trend", label: "Trend", icon: "folder", children: [{ id: "i-sma", label: "Moving Average", icon: "indicator", ind: "SMA" }, { id: "i-ema", label: "Exponential Moving Average", icon: "indicator", ind: "EMA" }, { id: "i-bb", label: "Bollinger Bands", icon: "indicator", ind: "BB" }] },
    { id: "osc", label: "Oscillators", icon: "folder", children: [{ id: "i-rsi", label: "Relative Strength Index", icon: "indicator", ind: "RSI" }, { id: "i-macd", label: "MACD", icon: "indicator", ind: "MACD" }, { id: "i-sto", label: "Stochastic Oscillator", icon: "indicator", ind: "STOCH" }] },
    { id: "vol", label: "Volumes", icon: "folder", children: [{ id: "i-vol", label: "Volumes", icon: "indicator", ind: "VOL" }] },
  ] },
  { id: "ea", label: "Expert Advisors", icon: "folder", children: [{ id: "ex", label: "Examples", icon: "folder", children: [{ id: "e1", label: "MACD Sample", icon: "expert", ea: true }, { id: "e2", label: "Moving Average", icon: "expert", ea: true }] }] },
  { id: "sc", label: "Scripts", icon: "folder", children: [{ id: "s1", label: "Close All Positions", icon: "script", script: "closeAll" }, { id: "s2", label: "Delete All Objects", icon: "script", script: "objects" }] },
  { id: "svc", label: "Services", icon: "folder", children: [{ id: "sv1", label: "Price Feed Monitor", icon: "service" }] },
  { id: "mkt", label: "Market", icon: "folder" },
  { id: "vps", label: "VPS", icon: "folder" },
];

export default function Navigator() {
  const st = useStore();
  const [open, setOpen] = useState({ acc: true, srv: true, ind: true, trend: true, osc: true });
  const [sel, setSel] = useState(null);

  const activate = (n) => {
    if (n.ind === "VOL") return setChart({ volumes: true });
    if (n.ind) return addIndicator(n.ind);
    if (n.ea) return log(`expert ${n.label} loaded successfully on chart (algo trading ${st.algo ? "enabled" : "disabled"})`, "Experts", "experts");
    if (n.script === "closeAll") return getState().positions.map((p) => p.ticket).forEach((t) => closePosition(t, "script"));
    if (n.script === "objects") return setChart({ drawings: [] });
    if (n.children) setOpen((o) => ({ ...o, [n.id]: !o[n.id] }));
  };

  const node = (n, depth) => (
    <div key={n.id}>
      <div
        className={`nav-row ${sel === n.id ? "sel" : ""}`}
        style={{ paddingLeft: 4 + depth * 16 }}
        data-testid={`nav-${n.id}`}
        draggable={!!n.ind}
        onDragStart={(e) => n.ind && n.ind !== "VOL" && e.dataTransfer.setData("text/plain", JSON.stringify({ kind: "indicator", value: n.ind }))}
        onClick={() => setSel(n.id)}
        onDoubleClick={() => activate(n)}
        onContextMenu={(e) => { setSel(n.id); openMenu(e, [{ label: n.children ? (open[n.id] ? "Collapse" : "Expand") : n.ind ? "Attach to Chart" : n.ea ? "Attach to Chart" : n.script ? "Execute" : "Open", onClick: () => activate(n) }, { sep: true }, { label: "Refresh" }, { label: "Create in Editor", disabled: true }]); }}
      >
        <span className="nav-exp" onClick={(e) => { e.stopPropagation(); n.children && setOpen((o) => ({ ...o, [n.id]: !o[n.id] })); }} data-testid={`nav-toggle-${n.id}`}>
          {n.children ? (open[n.id] ? "−" : "+") : ""}
        </span>
        {I[n.icon]({ open: open[n.id] })}
        <span className="nav-label">{n.label}</span>
      </div>
      {n.children && open[n.id] && n.children.map((c) => node(c, depth + 1))}
    </div>
  );

  return (
    <div className="mt-panel nav" data-testid="navigator">
      <div className="mt-panel-title">
        <span>Navigator</span>
        <button className="mt-panel-close" data-testid="navigator-close" onClick={() => setUI({ panels: { ...st.panels, navigator: false } })}><I.close /></button>
      </div>
      <div className="mt-scroll nav-tree">{TREE.map((n) => node(n, 0))}</div>
      <div className="mt-panel-tabs">
        <div className="mt-tab active">Common</div>
        <div className="mt-tab">Favorites</div>
      </div>
    </div>
  );
}
